import { React, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Grid, TextField } from "@material-ui/core";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import { useForm,Form } from "./useFormPassword";
import Controls from "../global/controls/Controls";
import { useEffect } from "react";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const ResetPasswordStaff = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [resetpassword, setResetPassword] = useState({
    staff_id: "",
    password: "",
    password_confirmation: "",
  });
  const handeleInput = (e) => {
    e.persist();
    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };
  const loginSubmit = (e) => {
    e.preventDefault();
    if(validate()){
      setLoading(true);

    const data = {
      staff_id: location.state.id,
      password: loginInput.password,
      password_confirmation: loginInput.password_confirmation,
    };

    axios
      .post(
        `${BaseUrl}/api/resetPassword`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.status === true) {
          setLoading(false);
          sweetalert("تم تغيير كلمة المرور بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          }).then(() => {
            navigate("/staff");
          });
          
        }
      });
    }
  };
  const initialFValues = {
    staff_id: "",
    password: "",
    password_confirmation: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("password" in fieldValues) {
      if (fieldValues.password == "") {
        temp.password = "كلمة السر مطلوبة";
      } else if (fieldValues.password.length < 8  || !/[A-Z]/.test(fieldValues.password) || !/[a-z]/.test(fieldValues.password) || !/\d/.test(fieldValues.password) || !/[@#$%^&+=]/.test(fieldValues.password)) {
        temp.password = "يجب أن تكون كلمة السر مؤلفة من 8 محارف وتحوي أحرف صغيرة وكبيرة ورموز وأرقام";
      } else {
        temp.password = "";
      }
    }
    
    if ("password_confirmation" in fieldValues) {
        if (fieldValues.password_confirmation == "") {
          temp.password_confirmation = "كلمة السر مطلوبة";
        } 
        else if (fieldValues.password_confirmation.length < 8  || !/[A-Z]/.test(fieldValues.password_confirmation) ) {
          temp.password_confirmation = "يجب أن تكون كلمة السر مؤلفة من 8 محارف وتحوي أحرف صغيرة وكبيرة ورموز وأرقام";
        } 
        else if (fieldValues.password_confirmation !== loginInput.password) {
          temp.password_confirmation = "يجب أن تكون مطابقة لكلمة السر";
        } 
        else {
          temp.password_confirmation = "";
        }
      
    }
    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };

  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
  } = useForm(initialFValues, true, validate, );
  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div>
     <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={loginSubmit}
      >
        <Grid container>
          <Grid
            container
            item
            alignItems="center"
            direction="column"
            justify="center"
            xs={12}
            lg={12}
            md={12}
            sm={6}
            style={{ paddingRight: "14%" }}
          >
            <div>
              <h2 className="title-home">إعادة تعيين كلمة المرور</h2>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                container
                item
                alignItems="center"
                direction="column"
                justify="center"
                xs={12}
                lg={4}
                md={4}
                sm={6}
                style={{ padding: 10 }}
              >
                <Controls.Input
                  className="form-control"
                  variant="outlined"
                  fullWidth
                  label="كلمة المرور"
                  
                  type="password"
                  name="password"
                  onChange={handleInputChange}
                  value={loginInput.password}
                  error={errors.password}
               
                />
   
              </Grid>
              <Grid
                container
                item
                alignItems="center"
                direction="column"
                justify="center"
                xs={12}
                lg={4}
                md={4}
                sm={6}
                style={{ padding: 10 }}
              >
                <Controls.Input
                  className="form-control"
                  variant="outlined"
                  fullWidth
                  label="تأكيد كلمة المرور"
                  type="password"
                  name="password_confirmation"
                  onChange={handleInputChange}
                  value={loginInput.password_confirmation}
                  error={errors.password_confirmation}
              
                />
              </Grid>
            </div>

            <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <Controls.Button
              type="submit"
              text="تعديل"
              onClick={handeleInput}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          )}
        </Grid>
          </Grid>
        </Grid>
      </Form>
    </div>
  );
};
